import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dimmer, Loader, Message } from 'semantic-ui-react';
import { SemanticToastContainer } from 'react-semantic-toasts';

import {
  clearKycContactDetail,
  loadKycContactDetail,
  loadKycContactList,
} from 'state/kyc/actions';

import ActionBar from './ActionBar';
import ContactsTable from './ContactsTable';
import ContactDetail from './ContactDetail';
import styles from './ContactDetail.module.css';

const SIZE = 10;
const STATUS_ALL = 'ALL';
const DEFAULT_FILTERS = {
  status: STATUS_ALL,
  npwpStatus: STATUS_ALL,
  searchBy: null,
  searchValue: '',
};

function KycContactListPage() {
  const dispatch = useDispatch();
  const { data, paging, isLoading, detail } = useSelector(state => state.kyc);
  const isBodyLoading = isLoading || detail.isLoading;

  const [selectedContactId, setSelectedContactId] = useState(null);
  const [activePage, setActivePage] = useState(paging.page || 1);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const onSearch = ({ searchBy, searchValue }) => {
    setActivePage(1);
    setFilters({ ...DEFAULT_FILTERS, searchBy, searchValue });
  };
  const onContactSelected = contactId => {
    setSelectedContactId(contactId);
    dispatch(loadKycContactDetail(contactId));
  };
  const onBackToList = () => {
    setSelectedContactId(null);
    dispatch(clearKycContactDetail());
  };
  const onPageChangeRaw = (e, { activePage: page }) => setActivePage(page);

  // the detail endpoint doesn't return submission_date, so carry it over
  const selectedListRow = data.find(row => row.id === selectedContactId);

  useEffect(() => {
    dispatch(loadKycContactList(activePage, SIZE, filters));
  }, [dispatch, activePage, filters]);

  const renderBody = () => {
    if (!selectedContactId) {
      return (
        <ContactsTable
          contacts={data}
          activePage={activePage}
          totalCount={paging.total}
          pageSize={paging.size}
          onContactSelected={onContactSelected}
          onPageChange={onPageChangeRaw}
        />
      );
    }
    if (!detail.data) {
      // empty placeholder so the Dimmer below has an area to cover while
      // the detail request is in flight
      return <div style={{ minHeight: 200 }} />;
    }
    return (
      <ContactDetail
        contact={detail.data}
        submissionDate={selectedListRow && selectedListRow.submission_date}
        onBackToList={onBackToList}
      />
    );
  };

  return (
    <>
      <SemanticToastContainer size="small" />
      <h1>KYC Contact List</h1>
      <br />
      <ActionBar onSearch={onSearch} />
      {selectedContactId ? (
        <>
          <Message info>
            This is historical data imported from Salesforce, from QRIS/e-wallet
            registration — separate from the KYB Review module.
            <br />
            Bank details reflect what was first submitted, not the current live
            account in Backoffice.
          </Message>
          <Button
            basic
            icon="angle left"
            content="Back to list"
            onClick={onBackToList}
            className={styles['back-button']}
          />
        </>
      ) : (
        <Message info>
          Showing all records — imported from Salesforce, separate from KYB
          Review.
        </Message>
      )}

      <Dimmer.Dimmable dimmed={isBodyLoading}>
        <Dimmer active={isBodyLoading} inverted>
          <Loader>Loading...</Loader>
        </Dimmer>
        {renderBody()}
      </Dimmer.Dimmable>
    </>
  );
}

export default KycContactListPage;
